import { createSelector } from 'reselect';
 
const selectOrganizationUnits = (state: any) => state.organizationUnits;
 
export const selectCurrentItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.current);
 
export const selectListItems = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.list);
 
 
export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectCreatedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.create);
 
export const selectUpdatedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.update);
 
export const selectReadItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.read);
 
export const selectDeletedItem = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.delete);
 
export const selectSearchedItems = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.search);
 
export const selectItemsCount = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.count);
 
export const selectItemsFilter = createSelector([selectOrganizationUnits], (organizationUnits) => organizationUnits.filter);